export default {
  About: 'À propos',
  Resume: 'Mon CV',
  Projects: 'Projets',
  Stats: 'Stats',
  Contact: 'Contact',
  aboutMe: 'À propos',

  resume: 'Mon CV',
  education: 'education',
  conferences: 'conférences',

  unbabel_position: 'Traducteur Anglais - Français',
  unbabel_point0: 'Traduction de documents et de textes en provenance de différentes entreprises et industries',

  Apple_company: 'Apple',
  Apple_position: 'Stagiaire en vérication AMS - équipe PMU',
  Apple_point0: 'Travail sur la vérification des prochains PMUs d\'Apple',
  Apple_point1: 'Création de composants VAMS pour accélérer les simulations, mesures sur puces pour tester des fonctionnalités expérimentales',

  XMCO_company: 'XMCO',
  XMCO_position: 'Pentesteur',
  XMCO_point0: 'Participation à divers types d\'audit de sécutité (Web, Active Directory, Postes de Travail, Audits de configuration...)',
  XMCO_point1: 'Gestion de projets depuis le contact initial avec le client jusqu\'à la livraison du rapport',
  XMCO_point2: 'Intégration dans la Red Team XMCO, où j\'ai pu participer à des engagements de l\'accès initial au mouvement vers les objectifs',

  talk_ese2026: 'ESE 2026',
  ese2026_title: 'TPM Sniffing: Théorie et Pratique',
  ese2026_point0: 'Conférence sur mon expérience avec le TPM sniffing, les erreurs communes et comment les détecter',
  ese2026_point1: 'Fait juste après la sortie de YellowKey :-)',

  Some_stats_about_me: 'Quelques statistiques sur moi',
  Some_stats_about_the_website: 'Quelques statistiques sur le site web',
  Current_age: 'Âge actuel',
  Countries_visited: 'Pays visités',
  Current_city: 'Ville actuelle',
  Github_stars: 'Étoiles que ce dépôt a sur Github',
  Watchers: 'Nombre de personnes surveillant ce dépôt',
  Forks: 'Nombre de forks',
  Spoons: 'Nombre de cuillères',
  Linter_warnings: 'Nombre d\'avertissements du linter',
  Open_issues: 'Nombre de problèmes ouverts sur Github',
  Last_update: 'Mis à jour le',
  Javascript_lines: 'Lignes de Javascript faisant fonctionner ce site web',

};
